import React from 'react';
import { Box, Typography, Divider } from '@mui/material';
import { useLocation } from 'react-router-dom';
import AppLayout from '../components/layout/AppLayout';
import NewChatForm from '../components/chat/NewChatForm';

interface LocationState {
  initialMessage?: string;
  type?: 'car_listing' | 'vin_analysis' | 'general';
}

const NewChatPage: React.FC = () => {
  const location = useLocation();
  const state = location.state as LocationState;

  const getTitle = () => {
    switch (state?.type) {
      case 'car_listing':
        return 'Analyze Car Listing';
      case 'vin_analysis':
        return 'VIN Analysis';
      default:
        return 'Start a New Chat';
    }
  };

  const getDescription = () => {
    switch (state?.type) {
      case 'car_listing':
        return 'Get detailed analysis and insights for the car listing.';
      case 'vin_analysis':
        return 'Get comprehensive vehicle history and analysis.';
      default:
        return 'Chat with the assistant about any car-related questions you have.';
    }
  };

  return (
    <AppLayout>
      <Box sx={{ maxWidth: 800, mx: 'auto', px: { xs: 2, sm: 3 } }}>
        <Typography variant="h4" gutterBottom sx={{ fontSize: { xs: '1.75rem', sm: '2.125rem' } }}>
          {getTitle()}
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          {getDescription()}
        </Typography>
        <Divider sx={{ mb: 3 }} />
        <NewChatForm 
          initialMessage={state?.initialMessage}
          chatType={state?.type}
        />
      </Box>
    </AppLayout>
  );
};

export default NewChatPage;
